import React from 'react'
import { connect } from 'react-redux';

import Manager from './Manager';
import Editor from './Editor';

import { closeDialog } from '../../../store/dialogs/actions';

const DialogStateContext = React.createContext({});

function DeleteForm (props) {
    const dialogState = props.dialogs[props.dialogName];
    const RenderDialog = dialogState.data.fromEditor ? Editor : Manager;

    const closeDialog = () => props.closeDialog(props.dialogName);

    return (
        <DialogStateContext.Provider value={dialogState}>
            <RenderDialog handleClose={closeDialog} />
        </DialogStateContext.Provider>
    );
}

const mapStateToProps = state => ({
    dialogs: state.dialogs
});

const mapDispatchToProps = dispatch => ({
    closeDialog: name => dispatch(closeDialog(name))
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteForm);
export { DialogStateContext };
